module.exports = __webpack_public_path__ + "static/mission-img-8-ca7329bb5c100a607e58d42f0c831f3c.jpg";